import { initSponsorshipOpportunities } from "./sponsorship-opportunities";
import { initSectionEarningPoints } from "./section-earning-points";
import { initTravelAccordion } from "./travel-accordion";
import { initChapterNews } from "./section-chapter-news";
import { initPastBoardMeetings } from "./pastboardmeetings";
import {
  initWsapGuidelines,
  initWsapResources,
} from "./sectionwsapresources";
function reinitAll() {
  if (document.querySelector(".travel-accordian-trigger")) {
    safeRun(initTravelAccordion);
  }
  if (
    document.querySelector('[data-testid="section-sponsorship-opportunities"]')
  ) {
    safeRun(initSponsorshipOpportunities);
  }
  if (document.querySelector('[data-testid="section-earning-points"]')) {
    safeRun(initSectionEarningPoints);
  }
  if (document.querySelector('[data-testid="section-chapter-news"]')) {
    safeRun(initChapterNews);
  }
  if (document.querySelector('[data-testid="section-past-board-meetings"]')) {
    safeRun(initPastBoardMeetings);
  }
  if (document.querySelector("#wsap-resources")) {
    safeRun(initWsapResources);
  }
  if (document.querySelector(".wsap-guide-trigger")) {
    safeRun(initWsapGuidelines);
  }
  if (document.querySelector("[data-wsap-config]")) {
    safeRun(window.initCompetitiveEventListings);
  }
}
document.addEventListener("ajax:loaded", () => {
  if (document.querySelector(".travel-accordian-trigger")) {
    safeRun(initTravelAccordion);
  }
});
// ---------- Global state ----------
const ajaxCache = {}; // key: absolute URL
let currentActiveUrl = null;
let isNavigating = false;
let tabHandlerAttached = false;

// ---------- Helpers ----------
function getTabFromHash() {
  return location.hash ? location.hash.replace("#", "") : null;
}

function toAbsoluteUrl(href) {
  try {
    return new URL(href, location.origin).href;
  } catch (e) {
    return href;
  }
}

function safeRun(fn) {
  try {
    if (typeof fn === "function") fn();
  } catch (e) {
    console.warn("Initializer failed:", fn.name, e);
  }
}

function loadScriptOnce(src, callback) {
  if (document.querySelector(`script[src="${src}"]`)) {
    if (callback) callback();
    return;
  }
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  script.onload = () => callback && callback();
  document.head.appendChild(script);
}

function updateMetaTags(doc) {
  const newTitle = doc.querySelector("title");
  if (newTitle) document.title = newTitle.textContent;

  const newDescription = doc.querySelector('meta[name="description"]');
  const currentDescription = document.querySelector('meta[name="description"]');
  if (newDescription && currentDescription) {
    currentDescription.setAttribute(
      "content",
      newDescription.getAttribute("content"),
    );
  }

  const head = document.querySelector("head");
  doc.querySelectorAll('meta[property^="og:"]').forEach((newMeta) => {
    const prop = newMeta.getAttribute("property");
    const existing = head.querySelector(`meta[property="${prop}"]`);
    if (existing) {
      existing.setAttribute("content", newMeta.getAttribute("content"));
    } else {
      head.appendChild(newMeta.cloneNode(true));
    }
  });
}

function updateAdminBarLinks(doc) {
  try {
    const newEdit = doc.querySelector("#wp-admin-bar-edit a");
    const newView = doc.querySelector("#wp-admin-bar-view a");
    const curEdit = document.querySelector("#wp-admin-bar-edit a");
    const curView = document.querySelector("#wp-admin-bar-view a");

    if (newEdit && curEdit)
      curEdit.setAttribute("href", newEdit.getAttribute("href"));
    if (newView && curView)
      curView.setAttribute("href", newView.getAttribute("href"));
  } catch (e) {
    console.warn("Admin bar update failed:", e);
  }
}

function scrollToTarget(scrollTo, maxRetries = 10) {
  if (!scrollTo || !scrollTo.selector) return;

  let retries = 0;

  const tryScroll = () => {
    const target = document.querySelector(scrollTo.selector);

    if (target) {
      requestAnimationFrame(() => {
        const yOffset = scrollTo.offset || 0;
        const rect = target.getBoundingClientRect();
        const y = rect.top + window.pageYOffset + yOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      });
    } else if (retries < maxRetries) {
      retries++;
      setTimeout(() => requestAnimationFrame(tryScroll), 100);
    }
  };

  tryScroll();
}

// ---------- initTabs (desktop only) ----------
function initTabs(initialSlug) {
  const tabs = document.querySelectorAll(".ajax-tab.tab-btn");
  if (!tabs.length) return;

  let activeSlug = initialSlug ? toAbsoluteUrl(initialSlug) : null;
  const activeDesktop = document.querySelector(".ajax-tab.tab-btn.active");

  if (!activeSlug) {
    activeSlug = activeDesktop
      ? toAbsoluteUrl(
          activeDesktop.dataset.tab || activeDesktop.getAttribute("href"),
        )
      : toAbsoluteUrl(tabs[0].dataset.tab || tabs[0].getAttribute("href"));
  }

  const setActive = (t) => {
    t.classList.add("active");
  };

  const setInactive = (t) => {
    t.classList.remove("active");
  };

  tabs.forEach((t) => {
    const tUrl = toAbsoluteUrl(t.dataset.tab || t.getAttribute("href"));
    tUrl === activeSlug ? setActive(t) : setInactive(t);
  });
}

// ---------- Delegated click handler ----------
function attachTabHandler() {
  if (tabHandlerAttached) return;
  tabHandlerAttached = true;

  document.addEventListener("click", (e) => {
    const link = e.target.closest(".ajax-tab");
    if (!link) return;

    e.preventDefault();
    const hrefAbsolute = toAbsoluteUrl(link.href || link.getAttribute("href"));
    if (!hrefAbsolute || hrefAbsolute === "#") return;

    const scrollToObj = shouldScrollToTabs(link);

    const slug = toAbsoluteUrl(link.dataset.tab || hrefAbsolute);
    initTabs(slug);

    showTab(hrefAbsolute, {
      push: true,
      scrollTo: window.innerWidth >= 768 ? scrollToObj : null,
    });
  });
}

function shouldScrollToTabs(clickedEl) {
  const navigationTabs = ".page-with-section-nav";
  const subTabs = '[data-testid="navigation-subtabs"]';
  const contentWithTabs = '[data-testid="section-content-with-tabs"]';
  const contentTabs = "#content-tabs";

  if (clickedEl.closest(navigationTabs)) {
    return { selector: navigationTabs, offset: -100 };
  } else if (clickedEl.closest(subTabs)) {
    return { selector: subTabs, offset: -100 };
  } else if (clickedEl.closest(contentWithTabs)) {
    return { selector: contentTabs, offset: -50 };
  }
}

// ---------- Mobile dropdown (AJAX-safe) ----------
document.addEventListener("click", (e) => {
  const toggle = e.target.closest("#dropdown-toggle");
  if (!toggle) return;

  document.getElementById("dropdown-menu")?.classList.toggle("hidden");
});

document.addEventListener("click", (e) => {
  const item = e.target.closest(".tabs-dropdown-item.ajax-tab");
  if (!item) return;

  const label = document.getElementById("ajax-tabs-selected-options");
  if (label) label.textContent = item.textContent.trim();

  document.getElementById("dropdown-menu")?.classList.add("hidden");
});
document.addEventListener("click", (e) => {
  const conferenceSection = e.target.closest(
    '[data-testid="nlc-conference-details-section"]',
  );
  if (!conferenceSection) return;
  const button = e.target.closest("a:not(.ajax-tab)");
  if (!button) return;
  e.preventDefault();
  e.stopPropagation();
  const buttonHref = toAbsoluteUrl(button.href || button.getAttribute("href"));
  if (!buttonHref || buttonHref === "#") return;
  const matchingTab = Array.from(document.querySelectorAll(".ajax-tab")).find(
    (tab) => {
      const tabHref = toAbsoluteUrl(tab.href || tab.getAttribute("href"));
      return tabHref === buttonHref;
    },
  );
  if (matchingTab) {
    const isAlreadyActive = matchingTab.classList.contains("active");
    const isCurrentUrl = currentActiveUrl === buttonHref;
    if (isAlreadyActive || isCurrentUrl) {
      const slug = toAbsoluteUrl(matchingTab.dataset.tab || buttonHref);
      initTabs(slug);
      if (window.innerWidth >= 768) {
        const scrollToObj = shouldScrollToTabs(matchingTab);
        if (scrollToObj) {
          setTimeout(() => {
            scrollToTarget(scrollToObj);
          }, 100);
        }
      }
      return;
    }
    const hrefAbsolute = toAbsoluteUrl(
      matchingTab.href || matchingTab.getAttribute("href"),
    );
    if (!hrefAbsolute || hrefAbsolute === "#") return;

    const scrollToObj = shouldScrollToTabs(matchingTab);
    const slug = toAbsoluteUrl(matchingTab.dataset.tab || hrefAbsolute);
    initTabs(slug);

    showTab(hrefAbsolute, {
      push: true,
      scrollTo: window.innerWidth >= 768 ? scrollToObj : null,
    });
  }
});

// ---------- showTab ----------
async function showTab(
  url,
  { push = true, replace = false, scrollTo = null } = {},
) {
  const loader = document.querySelector(".pageLoader");
  const contentContainer = document.querySelector("#content");
  if (!contentContainer) return;

  if (isNavigating && url === currentActiveUrl) return;
  isNavigating = true;
  loader?.classList.remove("loaded");

  try {
    const absUrl = toAbsoluteUrl(url);

    if (!ajaxCache[absUrl]) {
      const response = await fetch(absUrl, { cache: "no-store" });
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      ajaxCache[absUrl] = await response.text();
    }

    const html = ajaxCache[absUrl];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const newContent = doc.querySelector("#content");

    if (!newContent) {
      console.warn("No #content in fetched HTML for:", absUrl);
      loader?.classList.add("loaded");
      isNavigating = false;
      return;
    }

    contentContainer.innerHTML = newContent.innerHTML;

    if (scrollTo) {
      requestAnimationFrame(() => {
        scrollToTarget(scrollTo);
      });
    }

    if (replace) history.replaceState(null, "", absUrl);
    else if (push) history.pushState(null, "", absUrl);
    currentActiveUrl = absUrl;

    if (!window.gsap) {
      loadScriptOnce(
        "https://cdn.jsdelivr.net/npm/gsap@3/dist/gsap.min.js",
        () => console.log("GSAP loaded ✅"),
      );
    }

    doc.querySelectorAll("script").forEach((script) => {
      try {
        const type = (script.getAttribute("type") || "").trim().toLowerCase();
        const isExecutableScript =
          !type ||
          [
            "text/javascript",
            "application/javascript",
            "application/ecmascript",
            "text/ecmascript",
            "module",
          ].includes(type);
        if (!isExecutableScript) return;

        const id = script.getAttribute("id");
        if (id && document.getElementById(id)) return;

        const src = script.getAttribute("src");
        const content = script.textContent || "";
        if (src && !document.querySelector(`script[src="${src}"]`)) {
          const ext = document.createElement("script");
          ext.src = src;
          ext.async = false;
          if (type) ext.type = type;
          if (id) ext.id = id;
          document.body.appendChild(ext);
        } else if (content.trim().length) {
          const patched = content.replace(
            /document\.addEventListener\(\s*["']DOMContentLoaded["']\s*,/g,
            "document.addEventListener('ajax:loaded',",
          );
          const inline = document.createElement("script");
          if (type) inline.type = type;
          if (id) inline.id = id;
          inline.textContent = patched;
          document.body.appendChild(inline);
        }
      } catch (e) {
        console.warn("Script execution error", e);
      }
    });

    updateMetaTags(doc);
    updateAdminBarLinks(doc);
    document.dispatchEvent(new Event("ajax:loaded"));
    reinitAll();

    requestIdleCallback(() => {
      if (doc.querySelector("[data-testid='section-navigation-tabs']"))
        safeRun(window.initProgramSearchSection);
      safeRun(window.initGlobalSlider);
    });
  } catch (err) {
    console.error("showTab error:", err);
  } finally {
    loader?.classList.add("loaded");
    isNavigating = false;
  }
}

// ---------- Preload tabs ----------
function preloadAjaxTabs() {
  document.querySelectorAll(".ajax-tab").forEach((link) => {
    const hrefAbsolute = toAbsoluteUrl(link.href || link.getAttribute("href"));
    if (!hrefAbsolute || hrefAbsolute === "#" || ajaxCache[hrefAbsolute])
      return;
    fetch(hrefAbsolute, { cache: "no-store" })
      .then((r) => {
        if (!r.ok) throw new Error("Network response was not ok");
        return r.text();
      })
      .then((html) => {
        ajaxCache[hrefAbsolute] = html;
        console.log("Preloaded:", hrefAbsolute);
      })
      .catch((err) => console.warn("Preload failed:", err));
  });
}

// ---------- Init on page load ----------
document.addEventListener("DOMContentLoaded", () => {
  attachTabHandler();
  initTabs(getTabFromHash());

  const activeTab = document.querySelector(".ajax-tab.active");
  const activeUrl = activeTab
    ? toAbsoluteUrl(activeTab.href || activeTab.getAttribute("href"))
    : toAbsoluteUrl(location.href);
  if (activeUrl && !ajaxCache[activeUrl]) {
    ajaxCache[activeUrl] = document.documentElement.outerHTML;
    currentActiveUrl = activeUrl;
    console.log("Cached current page:", activeUrl);
  }

  preloadAjaxTabs();

  window.addEventListener("popstate", () => {
    const loc = toAbsoluteUrl(location.href);
    initTabs(loc);
    showTab(loc, { push: false, replace: true });
  });

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => initTabs(getTabFromHash()), 200);
  });
});
